import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance } from 'intact-vue-next';
import { expandAnimationCallbacks } from '../utils';
// for TreeSelect to refresh position
export function useTransitionEvent() {
  var instance = useInstance();
  var _onAfterEnter = expandAnimationCallbacks.onAfterEnter,
    _onAfterLeave = expandAnimationCallbacks.onAfterLeave;
  return _extends({}, expandAnimationCallbacks, {
    onAfterEnter: function onAfterEnter(el) {
      instance.trigger('transitionEnd');
      _onAfterEnter(el);
    },
    onAfterLeave: function onAfterLeave(el) {
      instance.trigger('transitionEnd');
      _onAfterLeave(el);
    }
  });
}